import {
  getProspectAddress,
  getProspectChannel,
  getProspectCreatedDateFormatted,
  getProspectDisplayName,
  getProspectLeadStage,
  getProspectModifiedDateFormatted,
} from 'helpers/listViewProspectDisplay';
import { Prospect } from 'types/prospect';

type PipelineListViewColumnConfig = {
  id: string;
  label: string;
  width: number;
  getCellText: (prospect: Prospect) => string;
};

const PIPELINE_LIST_VIEW_COLUMNS: PipelineListViewColumnConfig[] = [
  {
    id: 'name',
    label: 'Name',
    width: 200,
    getCellText: getProspectDisplayName,
  },
  {
    id: 'address',
    label: 'Address',
    width: 200,
    getCellText: getProspectAddress,
  },
  {
    id: 'created',
    label: 'Created',
    width: 150,
    getCellText: getProspectCreatedDateFormatted,
  },
  {
    id: 'modified',
    label: 'Modified',
    width: 150,
    getCellText: getProspectModifiedDateFormatted,
  },
  {
    id: 'channel',
    label: 'Channel',
    width: 100,
    getCellText: getProspectChannel,
  },
  {
    id: 'stage',
    label: 'Stage',
    width: 150,
    getCellText: getProspectLeadStage,
  },
];

const PIPELINE_LIST_VIEW_ACTIONS_COLUMN_WIDTH = 24;

export {
  PIPELINE_LIST_VIEW_ACTIONS_COLUMN_WIDTH,
  PIPELINE_LIST_VIEW_COLUMNS,
  type PipelineListViewColumnConfig,
};
